module.exports = __webpack_public_path__ + "static/media/pdf.7ca53de4.svg";